import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import KioskConfigForm from '../components/kiosk/KioskConfigForm';
import KioskFigureCard from '../components/kiosk/KioskFigureCard';
import {
  KIOSK_CONFIG_QUERY,
  KIOSK_PUBLICATIONS_QUERY,
  KIOSK_PAGES_QUERY,
  KIOSK_PAGE_FIGURES_QUERY
} from '../graphql/queries';
import { UPDATE_KIOSK_CONFIG } from '../graphql/mutations';

// Museum kiosk mode (legacy /kiosk_configs/kiosk_config ERB page rebuilt on
// Apollo — the JSON routes are folded into GraphQL).
export default function KioskPage() {
  const [selectedPublicationId, setSelectedPublicationId] = useState(null);
  const [selectedPageId, setSelectedPageId] = useState(null);
  const [selectedFigureId, setSelectedFigureId] = useState(null);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  const { data: configData } = useQuery(KIOSK_CONFIG_QUERY);
  const { data: pubsData, loading: loadingPublications } = useQuery(KIOSK_PUBLICATIONS_QUERY);
  const { data: pagesData, loading: loadingPages } = useQuery(KIOSK_PAGES_QUERY, {
    variables: { publicationId: selectedPublicationId },
    skip: selectedPublicationId === null
  });
  const { data: figsData, loading: loadingFigures } = useQuery(KIOSK_PAGE_FIGURES_QUERY, {
    variables: { pageId: selectedPageId },
    skip: selectedPageId === null
  });
  const [updateKioskConfig] = useMutation(UPDATE_KIOSK_CONFIG);

  // Restore the saved kiosk config on first load.
  useEffect(() => {
    const config = configData?.kioskConfig;
    if (config && config.pageId != null && config.figureId != null) {
      setSelectedPublicationId(String(config.publicationId));
      setSelectedPageId(String(config.pageId));
      setSelectedFigureId(String(config.figureId));
    }
  }, [configData]);

  const publications = pubsData?.kioskPublications || [];
  const pages = pagesData?.kioskPages || [];
  const figures = figsData?.kioskPageFigures || [];
  const selectedFigure = figures.find((f) => f.id === selectedFigureId);

  const selectPublication = (publicationId) => {
    setSelectedPublicationId(publicationId);
    setSelectedPageId(null);
    setSelectedFigureId(null);
  };
  const selectPage = (pageId) => {
    setSelectedPageId(pageId);
    setSelectedFigureId(null);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setError(null);
    setSaved(false);
    try {
      const result = await updateKioskConfig({
        variables: { pageId: selectedPageId, figureId: selectedFigureId }
      });
      const payload = result.data.updateKioskConfig;
      if (payload.success) setSaved(true);
      else setError(payload.errors ? String(payload.errors) : 'Unknown error');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="page-content kiosk-config-container">
      <div className="row">
        <div className="col-lg-5">
          <div className="card mb-4">
            <div className="card-header bg-primary text-white">
              <h5 className="mb-0">
                <i className="bi bi-gear" /> Configure Kiosk
              </h5>
            </div>
            <div className="card-body">
              <KioskConfigForm
                publications={publications}
                pages={pages}
                figures={figures}
                loadingPublications={loadingPublications}
                loadingPages={loadingPages}
                loadingFigures={loadingFigures}
                selectedPublicationId={selectedPublicationId}
                selectedPageId={selectedPageId}
                selectedFigureId={selectedFigureId}
                saved={saved}
                onSelectPublication={selectPublication}
                onSelectPage={selectPage}
                onSelectFigure={setSelectedFigureId}
                onSave={handleSave}
              />
            </div>
          </div>
        </div>

        <div className="col-lg-7">
          <KioskFigureCard figure={selectedFigure} error={error} />
        </div>
      </div>
    </div>
  );
}
